module.exports = __webpack_public_path__ + "static/media/capa.8791fdb3.jpg";